import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import EdReadyReaderForm from '../forms/edReady-reader-form';
import { edReadyReaderValidationSchema } from '../schema/edReadyReader.js';

export default function EdReadyReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'EdReady Reader Node Details',
        altText: 'EdReady Reader Node',
        defaultLabel: 'EdReady Reader Node',
      }}
    >
      <CommonNode
        FormComponent={EdReadyReaderForm}
        schemaResolver={edReadyReaderValidationSchema}
      />
    </NodeProvider>
  );
}
